import { render, staticRenderFns } from "./Report2.vue?vue&type=template&id=18253892&"
import script from "./Report2.vue?vue&type=script&lang=js&"
export * from "./Report2.vue?vue&type=script&lang=js&"
import style0 from "./Report2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Report2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports